import React, { useEffect, useState } from "react";
import { api, brl } from "../../lib/api";

export default function AdminReports() {
  const [data, setData] = useState(null);
  useEffect(() => { (async () => setData((await api.get("/reports/overview")).data))(); }, []);
  if (!data) return <div className="text-sm tracking-widest uppercase text-[#5C5A57]">Carregando...</div>;

  return (
    <div data-testid="admin-reports-page">
      <div className="topbar">
        <h1 className="font-display text-4xl font-bold tracking-tight">Relatorios</h1>
      </div>

      <h2 className="section-title mb-4">Financeiro</h2>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-10">
        <div className="kpi-card"><div className="kpi-label">Total Vendido</div><div className="kpi-value tabular">{brl(data.financial.total_sold)}</div></div>
        <div className="kpi-card"><div className="kpi-label">Recebido</div><div className="kpi-value tabular">{brl(data.financial.total_received)}</div></div>
        <div className="kpi-card"><div className="kpi-label">Em Atraso</div><div className="kpi-value tabular">{brl(data.financial.total_overdue)}</div></div>
        <div className="kpi-card"><div className="kpi-label">Inadimplencia</div><div className="kpi-value tabular">{data.financial.default_rate}%</div></div>
      </div>

      <h2 className="section-title mb-4">Performance por Revendedora</h2>
      <div className="table-wrap mb-10">
        <table className="crl">
          <thead><tr><th>Revendedora</th><th>Clientes</th><th>Total Vendido</th><th>Taxa de Inadimplencia</th></tr></thead>
          <tbody>
            {data.resellers.map((r) => (
              <tr key={r.id}>
                <td className="font-medium">{r.name}</td>
                <td className="tabular">{r.clients}</td>
                <td className="tabular">{brl(r.total_sold)}</td>
                <td className="tabular">{r.default_rate}%</td>
              </tr>
            ))}
            {data.resellers.length === 0 && <tr><td colSpan="4" className="text-center text-sm text-[#5C5A57] py-8">Sem revendedoras cadastradas.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
